import axios from "@/lib/request";

const request = (url, method, payload = {}) =>
  axios.request({
    url,
    method,
    ...payload,
    headers: {
      AppKey: "BpLnfgDs",
      ...(payload.headers || {})
    }
  });

export const getClaimList = (risk, params) =>
  request(`/v1/admin/claim/${risk}/order/list`, "get", { params });
export const getClaimInfo = (risk, params) =>
  request(`/v1/admin/claim/${risk}/order/info`, "get", { params });
export const getPolicyInfo = (risk, params) =>
  request(`/v1/admin/claim/${risk}/order/policy_info`, "get", { params });
export const saveClaim = (risk, data) =>
  request(`/v1/admin/claim/${risk}/order/save`, "post", { data });
export const updateClaim = (risk, data) =>
  request(`/v1/admin/claim/${risk}/order/update`, "post", { data });
export const importClaims = (risk, data) =>
  request(`/v1/admin/claim/${risk}/order/import`, "post", { data });
export const finishClaim = (risk, data) =>
  request(`/v1/admin/claim/${risk}/order/finish`, "post", { data });
export const closeClaim = (risk, data) =>
  request(`/v1/admin/claim/${risk}/order/close`, "post", { data });
export const deleteClaim = (risk, data) =>
  request(`/v1/admin/claim/${risk}/order/delete`, "post", { data });

export const updateCargoAmount = data =>
  request("/v1/admin/claim/hyx/order/amount/update", "post", { data });
export const saveRecoveryFeasibility = data =>
  request("/v1/admin/claim/hyx/order/feasibility/save", "post", { data });
export const saveEmployerDamage = data =>
  request("/v1/admin/claim/ygx/order/damage/save", "post", { data });
export const saveEmployerLosses = data =>
  request("/v1/admin/claim/ygx/order/losses/save", "post", { data });

export const getStatusRecords = params =>
  request("/v1/admin/claim/hyx/order/status/list", "get", { params });
export const getStatusRecordInfo = params =>
  request("/v1/admin/claim/hyx/order/status/info", "get", { params });
export const saveStatusRecord = data =>
  request("/v1/admin/claim/hyx/order/status/save", "post", { data });
export const getProgressRecords = params =>
  request("/v1/admin/claim/hyx/order/progress/list", "get", { params });
export const getProgressRecordInfo = params =>
  request("/v1/admin/claim/hyx/order/progress/info", "get", { params });
export const saveProgressRecord = data =>
  request("/v1/admin/claim/hyx/order/progress/save", "post", { data });
export const getAuditRecords = params =>
  request("/v1/admin/claim/hyx/order/audit/list", "get", { params });
export const getAuditRecordInfo = params =>
  request("/v1/admin/claim/hyx/order/audit/info", "get", { params });
export const saveAuditRecord = data =>
  request("/v1/admin/claim/hyx/order/audit/save", "post", { data });
export const deleteAuditRecord = data =>
  request("/v1/admin/claim/hyx/order/audit/delete", "post", { data });

export const getClaimNotes = params =>
  request("/v1/admin/claim/order/note/list", "get", { params });
export const saveClaimNote = data =>
  request("/v1/admin/claim/order/note/save", "post", { data });
export const getClaimFiles = params =>
  request("/v1/admin/claim/hyx/order/file/list", "get", { params });
export const saveClaimFiles = data =>
  request("/v1/admin/claim/hyx/order/file/upload", "post", { data });
export const getClaimProductFiles = params =>
  request("/v1/admin/claim/productfile/list", "get", { params });

export const uploadClaimFile = data =>
  request("/res/file/upload", "post", { data, headers: {} });

export const getCargoTypes = params =>
  request("/v1/admin/claim/cargotype/list", "get", { params });
export const saveCargoType = data =>
  request("/v1/admin/claim/cargotype/save", "post", { data });
export const setCargoTypeDisabled = data =>
  request("/v1/admin/claim/cargotype/disable", "post", { data });
export const getCargoNames = params =>
  request("/v1/admin/claim/cargo/list", "get", { params });
export const saveCargoName = data =>
  request("/v1/admin/claim/cargo/save", "post", { data });
export const setCargoNameDisabled = data =>
  request("/v1/admin/claim/cargo/disable", "post", { data });

export const getReasons = (level, params) =>
  request(`/v1/admin/claim/reason/list/${level}`, "get", { params });
export const getReasonInfo = params =>
  request("/v1/admin/claim/reason/info", "get", { params });
export const saveReason = data =>
  request("/v1/admin/claim/reason/save", "post", { data });
export const setReasonDisabled = data =>
  request("/v1/admin/claim/reason/disable", "post", { data });

export const getIdentities = params =>
  request("/v1/admin/claim/identity/list", "get", { params });
export const getIdentityInfo = params =>
  request("/v1/admin/claim/identity/info", "get", { params });
export const saveIdentity = data =>
  request("/v1/admin/claim/identity/save", "post", { data });
export const setIdentityDisabled = data =>
  request("/v1/admin/claim/identity/disable", "post", { data });

export const getInsuranceCompanies = params =>
  request("/v1/admin/cmn/insurance/company/list", "get", { params });
export const getProducts = params =>
  request("/v1/admin/cmn/product/list", "get", { params });
export const getTopChannels = params =>
  request("/v1/admin/cmn/topchannel/list", "get", { params });
export const getProvinces = params =>
  request("/v1/admin/cmn/province/list", "get", { params });
export const getCities = params =>
  request("/v1/admin/cmn/city/list", "get", { params });
